import csiAction from "csi/action";
import Popup from "csi/action/Popup";
import def from "csi/def";
import Heading from "csi/def/Heading";
import { View } from "csi/def/View";
import { C8Node, cnl } from "csi/typings";
import MaterialIcon from "csi/widget/MaterialIcon";

/**
 * Creates an icon that opens up the 3D viewer when clicked
 */
export function create3DRotationIcon(view: View, refNode: Element, fileUrl: cnl, h: Heading, document: C8Node): boolean {
	new MaterialIcon({
		icon: "3d_rotation",
		onClick: (): void => {
			const action = Object.assign(new Popup(), {
				classController: "csi/threeD/ThreeDViewerController",
				m_id: "3DViewer",
				m_postAction: "postActionRefreshNode",
				m_typeControl: def.ACTION_ICON,
				dependencyPaths: ["Child:CurrentRevision"],
			});
			action.resolve();
			csiAction.invoke(view, refNode, action, {
				m_urlNode: fileUrl,
				docNode: document,
				getTitle: () => h.getLabel(),
			});
		},
	}).placeAt(refNode);
    
	return true;		
}